module.exports = __webpack_public_path__ + "static/media/elements_line_stop.4463a12c.svg";